module.exports = __webpack_public_path__ + "media/images/shark/SharkCafeMap-p-1080-6e7625148082ff89df662ed25e3c9e29.jpg";